import styled from 'styled-components'
import globals from '../globals'

export const TabNamesWrapper = styled.ul`
  margin:0 0 25px 0;
  padding:0;
  text-align: center;

  & > li {
    display: inline-block;

    & + li {
      margin-left:10px;
    }
  }
`

export const TabName = styled.li`
  color: ${globals.colors.darkblue};
`

const isActive = (props, retornoTrue, retornoFalse) => {
    return Number(props.index) === Number(props.currentIndex) ? retornoTrue : retornoFalse
}

export const TabNameButton = styled.button`
  margin:0;
  padding:0 12px;
  background:none;
  cursor: pointer;
  font-weight: ${props => isActive(props, '800', 'normal')};
  border:none;
  text-transform: uppercase;
  line-height: ${globals.inputs.lineHeight.normal};
  height: ${globals.inputs.lineHeight.normal};
  box-shadow: ${props => isActive(props, `inset 0 -3px 0 0 ${globals.colors.lightblue}`, `inset 0 -2px 0 0 ${globals.colors.darkblue}`)};
  color:${props => isActive(props, globals.colors.darkblue, globals.colors.gray)};
  transition: box-shadow .2s ease;

  &:focus {
    outline:none; 
    box-shadow: ${props => isActive(props, `inset 0 -3px 0 0 ${globals.colors.lightblue}`, `inset 0 -2px 0 0 ${globals.colors.darkblue}`)};
  }
`

export const TabWrapper = styled.div`
  color: #676767;
  font-weight: 300;
`